import { SignInIcon, ThemeIcon } from './icons';
import {
  SearchContentProvider,
  SearchProviderContext,
  SearchResultItem,
} from './types';

export class SystemActionsProvider implements SearchContentProvider {
  id = 'system-actions-provider';
  name = 'System Actions Provider';
  priority = 100; // High priority - system actions appear first

  getResults(context: SearchProviderContext): SearchResultItem[] {
    const results: SearchResultItem[] = [];

    // System actions are always shown regardless of badges
    // Add Set theme action - always visible
    results.push({
      id: 'set-theme',
      title: 'Set theme',
      subtitle: 'Choose between light and dark themes',
      type: 'system',
      priority: 95,
      action: 'navigate',
      actionKey: 'set-theme', // Navigate to the set-theme action
      icon: <ThemeIcon />,
      skipBadgeFiltering: true, // Always show regardless of badges
    });

    // Add Sign in action - only visible when NOT logged in
    if (!context.isLoggedIn) {
      results.push({
        id: 'sign-in',
        title: 'Sign in',
        subtitle: 'Sign in to your Flik account',
        type: 'system',
        priority: 90,
        action: 'navigate',
        actionKey: 'sign-in', // Navigate to the sign-in action
        icon: <SignInIcon />,
        skipBadgeFiltering: true, // Always show regardless of badges
      });
    }

    return results;
  }

  isActive(_context: SearchProviderContext): boolean {
    // System actions are always active
    return true;
  }
}
